module.exports = __webpack_public_path__ + "./assets/5ac8221c597c9d48c6956168dcf0b08e.svg";